import { useState } from "react";
import { DotLegalBreadCrumbModel } from "@dotlegal/dotlegal-ui-components";
import { useDotLegalQuery } from "@common/hooks/dotLegalReactQuery";
import { useTranslation } from "@localization/useTranslation";
import { ExternalUserViewModel } from "../ExternalUser.types";

export function useExternalUsersHook() {
    const { translateString } = useTranslation();
    const query = useDotLegalQuery<Array<ExternalUserViewModel>>("/external-users");

    const [showAddEditDialog, setShowAddEditDialog] = useState(false);
    const [showDeleteDialog, setShowDeleteDialog] = useState(false);
    const [selectedExternalUser, setSelectedExternalUser] = useState<ExternalUserViewModel>();

    async function refetch() {
        await query.refetch();
    }

    function getBreadCrumbs(): Array<DotLegalBreadCrumbModel> {
        return [{ name: translateString("externalUsers") }];
    }

    return {
        isLoading: query.isLoading,
        externalUsers: query.data,
        refetch,
        showAddEditDialog,
        setShowAddEditDialog,
        showDeleteDialog,
        setShowDeleteDialog,
        selectedExternalUser,
        setSelectedExternalUser,
        getBreadCrumbs,
    };
}
